import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type ForgotPassword } from "./types";

export default {
  submit: (
    apiInfo: ModuleApiInfo,
    args: ForgotPassword.Api.SubmitRequest
  ): Promise<HttpApiResponse<ForgotPassword.Api.SubmitResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/forgotPassword`, args)
};
